/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

 export default {
  locale: 'ka',
  Pagination: {
    items_per_page: '/ გვ.',
    jump_to: 'გადასვლა',
    jump_to_confirm: 'დადასტურება',
    page: '',
    prev_page: 'წინა გვერდი',
    next_page: 'შემდეგი გვერდი',
    prev_5: 'წინა 5 გვერდი',
    next_5: 'შემდეგი 5 გვერდი',
    prev_3: 'წინა 3 გვერდი',
    next_3: 'შემდეგი 3 გვერდი'
  },
  DatePicker: {
    lang: {
      placeholder: 'აირჩიეთ თარიღი',
      yearPlaceholder: 'აირჩიეთ წელი',
      quarterPlaceholder: 'აირჩიეთ კვარტალი',
      monthPlaceholder: 'აირჩიეთ თვე',
      weekPlaceholder: 'აირჩიეთ კვირა',
      rangePlaceholder: ['დაწყების თარიღი', 'დასრულების თარიღი'],
      rangeYearPlaceholder: ['დაწყების წელი', 'დასრულების წელი'],
      rangeMonthPlaceholder: ['დაწყების თვე', 'დასრულების თვე'],
      rangeWeekPlaceholder: ['დაწყების კვირა', 'დასრულების კვირა'],
      locale: 'ka_GE',
      today: 'დღეს',
      now: 'ახლა',
      backToToday: 'მიმდინარე თარიღი',
      ok: 'დიახ',
      clear: 'გასუფთავება',
      month: 'თვე',
      year: 'წელი',
      timeSelect: 'აირჩიეთ დრო',
      dateSelect: 'აირჩიეთ თარიღი',
      weekSelect: 'აირჩიეთ კვირა',
      monthSelect: 'აირჩიეთ თვე',
      yearSelect: 'აირჩიეთ წელი',
      decadeSelect: 'აირჩიე ათწლეული',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'წინა თვე (PageUp)',
      nextMonth: 'შემდეგი თვე (PageDown)',
      previousYear: 'წინა წელი (Control + left)',
      nextYear: 'შემდეგი წელი (Control + right)',
      previousDecade: 'წინა ათწლეული',
      nextDecade: 'შემდეგი ათწლეული',
      previousCentury: 'წინა საუკუნე',
      nextCentury: 'შემდეგი საუკუნე'
    },
    timePickerLocale: {
      placeholder: 'აირჩიეთ დრო',
      rangePlaceholder: ['დაწყების დრო', 'დასრულების დრო']
    }
  },
  TimePicker: {
    placeholder: 'აირჩიეთ დრო',
    rangePlaceholder: ['დაწყების დრო', 'დასრულების დრო']
  },
  Calendar: {
    lang: {
      placeholder: 'აირჩიეთ თარიღი',
      yearPlaceholder: 'აირჩიეთ წელი',
      quarterPlaceholder: 'აირჩიეთ კვარტალი',
      monthPlaceholder: 'აირჩიეთ თვე',
      weekPlaceholder: 'აირჩიეთ კვირა',
      rangePlaceholder: ['დაწყების თარიღი', 'დასრულების თარიღი'],
      rangeYearPlaceholder: ['დაწყების წელი', 'დასრულების წელი'],
      rangeMonthPlaceholder: ['დაწყების თვე', 'დასრულების თვე'],
      rangeWeekPlaceholder: ['დაწყების კვირა', 'დასრულების კვირა'],
      locale: 'ka_GE',
      today: 'დღეს',
      now: 'ახლა',
      backToToday: 'მიმდინარე თარიღი',
      ok: 'დიახ',
      clear: 'გასუფთავება',
      month: 'თვე',
      year: 'წელი',
      timeSelect: 'აირჩიეთ დრო',
      dateSelect: 'აირჩიეთ თარიღი',
      weekSelect: 'აირჩიეთ კვირა',
      monthSelect: 'აირჩიეთ თვე',
      yearSelect: 'აირჩიეთ წელი',
      decadeSelect: 'აირჩიე ათწლეული',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'წინა თვე (PageUp)',
      nextMonth: 'შემდეგი თვე (PageDown)',
      previousYear: 'წინა წელი (Control + left)',
      nextYear: 'შემდეგი წელი (Control + right)',
      previousDecade: 'წინა ათწლეული',
      nextDecade: 'შემდეგი ათწლეული',
      previousCentury: 'წინა საუკუნე',
      nextCentury: 'შემდეგი საუკუნე'
    },
    timePickerLocale: {
      placeholder: 'აირჩიეთ დრო',
      rangePlaceholder: ['დაწყების დრო', 'დასრულების დრო']
    }
  },
  global: {
    placeholder: 'აირჩიეთ'
  },
  Table: {
    filterTitle: 'ფილტრი',
    filterConfirm: 'დიახ',
    filterReset: 'განულება',
    filterEmptyText: 'ფილტრები არ არის',
    emptyText: 'მონაცემები არ არის',
    selectAll: 'აირჩიეთ მიმდინარე გვერდი',
    selectInvert: 'გვერდის მიმართულების შეცვლა',
    selectionAll: 'აირჩიეთ ყველა მონაცემი',
    sortTitle: 'სორტირება',
    expand: 'მწკრივის გაშლა',
    collapse: 'მწკრივის ჩაკეცვა',
    triggerDesc: 'დააჭირეთ კლებადობით დასალაგებლად',
    triggerAsc: 'დააჭირეთ ზრდადობით დასალაგებლად',
    cancelSort: 'დააჭირეთ დალაგების გასაუქმებლად'
  },
  Modal: {
    okText: 'დიახ',
    cancelText: 'გაუქმება',
    justOkText: 'დიახ'
  },
  Popconfirm: {
    okText: 'დიახ',
    cancelText: 'გაუქმება'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'ძიება',
    itemUnit: 'ელემ.',
    itemsUnit: 'ელემ.',
    remove: 'Remove',
    selectCurrent: 'აირჩიეთ მიმდინარე გვერდი',
    removeCurrent: 'წაშალეთ მიმდინარე გვერდი',
    selectAll: 'აირჩიეთ ყველა მონაცემი',
    removeAll: 'წაშალეთ ყველა მონაცემი',
    selectInvert: 'მიმდინარე გვერდის შებრუნება'
  },
  Upload: {
    uploading: 'იტვირტება...',
    removeFile: 'ფაილის წაშლა',
    uploadError: 'ატვირთვის შეცდომა',
    previewFile: 'ფაილის გადახედვა',
    downloadFile: 'ფაილის ჩამოტვირთვა'
  },
  Empty: {
    description: 'მონაცემი არ არის'
  },
  Icon: {
    icon: 'ხატულა'
  },
  Text: {
    edit: 'რედაქტირება',
    copy: 'კოპირება',
    copied: 'წარმატებით დაკოპირდა',
    expand: 'გახსნა'
  },
  PageHeader: {
    back: 'უკან'
  }
};
